/*------------------------------------*\
    FORM REVIEW
\*------------------------------------*/
import Bugsnag from "@bugsnag/js";
var base = require("../../site/_data/base");
var transmission = require("../../site/_data/transmission");
const axios = require('axios');
const FormData = require('form-data');

if (base.consultation.bugsnagApiKey) {
    Bugsnag.start(base.consultation.bugsnagApiKey);
}

class FormReviewTransmission {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        //self.calculateProgress();
        self.populateTable();
        self.populateHiddenFields();
        self.checkRequiredFields();
        self.submit();
    }

    calculateProgress() {
        let self = this;
        let fields = self.getLocalStorage();
    }

    checkRequiredFields() {
        // Check if user's personal details are complete
        if (!localStorage.getItem("your-details-section")) {
            document
                .getElementById("required-fields")
                .classList.toggle("d-none");
            document
                .getElementById("feedback-ready")
                .classList.toggle("d-none");
        }
    }

    populateTable() {
        let self = this;
        let table = self.elem.querySelector("[data-fields]");

        // Get all item from local storage
        let fields = self.getLocalStorage();

        fields.sort(function (a, b) {
            if (a.name < b.name) {
                return -1;
            }

            if (a.name > b.name) {
                return 1;
            }

            return 0;
        });

        // Loop through the items
        fields.forEach((field) => {
            if(Array.isArray(field.value)) {

                let arrFields = [];
                field.value.forEach((value) => {
                    arrFields.push(value.label);
                })

                arrFields = arrFields.join(", <br>");

                // Create the markup for a table row
                let markup = `
                    <tr>
                        <th scope="row">${field.label}</th>
                        <td>${arrFields}</td>
                    </tr>
                `;

                // Insert the table row inside the table body
                table.insertAdjacentHTML('beforeend', markup);
            } else {
                // Check they key isn't marked as hidden
                if(!field.name.includes('hidden')) {
                    // Create the markup for a table row
                    let markup = `
                        <tr>
                            <th scope="row">${field.label}</th>
                            <td>${field.value == "" ? "-" : self.nl2br(field.value)}</td>
                        </tr>
                    `;

                    // Insert the table row inside the table body
                    table.insertAdjacentHTML('beforeend', markup);  
                }
            }
        });
    }

    populateHiddenFields() {
        let self = this;

        // Get all item from local storage
        let fields = self.getLocalStorage();

        fields.sort(function(a, b){
            if(a.name < b.name) {
                return -1;
            }

            if(a.name > b.name) {
                return 1;
            }

            return 0;
        });

        // Loop through the items
        fields.forEach(field => {
            // Create the markup for a hidden input
            let markup = document.createElement('input');
            markup.setAttribute('type', 'hidden');
            markup.setAttribute('name', field.name);
            markup.setAttribute('value', field.value);
            self.elem.append(markup);
        });
    }

    // Get all items from local storage and convert to array
    // containing an object for each item
    getLocalStorage() {
        let self = this;

        let archive = [],
            keys = Object.keys(localStorage),
            i = 0,
            key;

        // Accept question data from local storage only. 
        // Prevents extension keys from interfering with feedback data
        for (; (key = keys[i]); i++) {
            transmission.consultation.sections.forEach((section) => {
                section.questions.forEach((question) => {
                    if (key.includes(question.name)) {
                        let data = JSON.parse(localStorage.getItem(key));

                        if (data) {
                            archive.push({
                                name: key,
                                label: data.label,
                                value: data.value,
                            });  
                        }
                    }
                })
            })
        }

        return archive;
    }

    submit() {
        let self = this;

        // When the form submit button is clicked...
        self.elem.addEventListener("submit", (evt) => {
            // Prevent the form from submitting
            evt.preventDefault();

            if (base.consultation.hasMap) {
                // If consultation map exists, send report
                self.sendFeedbackReport();
            } else {
                // Submit the form to Catcher
                self.elem.submit();
                // Clear local storage
                localStorage.clear();
            }
        });
    }

    sendFeedbackReport() {
        let self = this;

        // Append required data in acceptable format for api endpoint
        var data = new FormData();

        transmission.consultation.sections.forEach((section) => {
            section.questions.forEach((question) => {
                let question_value;
                let database_column = question.name.split("-").pop().trim();

                // Check for question key in local storage which is not null
                if (localStorage.getItem(question.name) && localStorage.getItem(question.name).value != '') {
                    question_value = JSON.parse(localStorage.getItem(question.name)).value.trim();

                    // Add question data to FormData()
                    data.append((question.number ? question.number + '-' : '') + database_column, question_value);
                }

                // Check if question has options (radio/checkbox)
                if (question.options) {
                    if (localStorage.getItem(question.name + "-options") && localStorage.getItem(question.name + "-options").value != '') {
                        question_value = JSON.parse(localStorage.getItem(question.name + "-options")).value.trim();

                        // Add question data to FormData()
                        data.append((question.number ? question.number + '-' : '') + database_column, question_value);
                    }
                }

                // Check if question has additional questions
                if (question.additional_questions) {
                    let additional_question_value;

                    question.additional_questions.forEach((additional) => {
                        if (localStorage.getItem(additional.name) && localStorage.getItem(additional.name).value != '') {
                            additional_question_value = JSON.parse(localStorage.getItem(additional.name)).value.trim();

                            // Add additional question data to FormData()
                            data.append((question.number ? question.number + '-' : '') + database_column + '-additional-' + additional.number, additional_question_value);
                        }
                    });
                }
            });
        });

        // for (const value of data.keys()) {
        //     console.log(value);
        // }

        var config = {
            method: "post",
            url:
                transmission.consultation.mapUrl + "/api/feedback-form/" + transmission.consultation.mapId,
            headers: {
                key: "7jfecPuxW37r",
                secret: "asmZmd99SB6BskpC4euepz",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                // Submit the form
                self.elem.submit();

                // Redirect to success
                window.location.replace("/transmission/have-your-say/form/success");
                
                // Clear local storage
                localStorage.clear();
            })
            .catch(function (error) {
                // Send error to Bugsnag
                Bugsnag.notify(error);
                // Show error message to user
                document.getElementById("form-error").innerHTML =
                    "Sorry, there was an error trying to send your feedback, please check your submission and try again. If the problem persists please contact us on " + base.base.contact_email;
            });
    }

    // Convert carriage returns to line breaks for displaying textarea
    // content in the table
    nl2br(str, is_xhtml) {
        if (typeof str === "undefined" || str === null) {
            return "";
        }
        var breakTag =
            is_xhtml || typeof is_xhtml === "undefined" ? "<br />" : "<br>";
        return (str + "").replace(
            /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
            "$1" + breakTag + "$2"
        );
    }
}

export default FormReviewTransmission;
